import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { IAEventDocumentDetails } from '../../../../../shared/models/IAEventDocumentDetails';
import { MatSort } from '@angular/material/sort';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { IAEventAttendanceDetails } from '../../../../../shared/models/IAEventAttendanceDetails';

@Component({
  selector: 'app-vieweventdocuments',
  templateUrl: './vieweventdocuments.component.html',
  styleUrl: './vieweventdocuments.component.css'
})
export class VieweventdocumentsComponent implements OnInit {

  //private loadDataSubscription: Subscription = new Subscription();
  private loadEventDocSubscription: Subscription | null=null;
  private loadEventAttendanceSubscription: Subscription | null = null;

  private destroy$: Subject<void> = new Subject<void>();

  eventUpdationForm: FormGroup;

  eventId: any;
  uploadError: string | null = null;
  removedocumentuploadError: string | null = null;
  uploadAttError: string | null = null;
  result: any[] = [];
  data: any = {};
  //reportData: any[] = [];
  UniqueEventId: string = '';
  uniqueEventId: any;

  selectedItems: any[] = []; // To store selected items
  document: { name: string, file: File | null }[] = [];
  attendanc: { name: string, file: File | null }[] = [];
  isSubmitted = false;

  DocumentDetailsData: any[] = [];
  AttendanceDetailsData: any[] = [];
  msMeUserName = sessionStorage.getItem('userId');
  length: number = 0;
  pageSize: number = 20;
  displayedData: any[] = [];
  reportData: any[] = [];
  pageSizeOptions: number[] = [10, 20, 50, 100];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  DtoPagination =
    {
      "UniqueEventId": '',

      "PageNumber": 1,
      "PageSize": 20,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": ""
    }
  dataSource!: MatTableDataSource<IAEventDocumentDetails>
  //displayedColumns: string[] = ['Sr.No', 'IAUserName', 'Intervention', 'Interest', 'CreatedDate', 'DocumentName', 'Download']
  displayedColumns: string[] = ['SrNo', 'DocumentType', 'CreatedDate', 'DocumentName', 'Download'];

  dataSourceattendance!: MatTableDataSource<IAEventAttendanceDetails>
  displayedAttendanceColumns: string[] = ['SrNo', 'UdyamRegistrationNumber', 'NameOfEnterprise','ParticipantName','MobileNumber','EnrollmentId','CreatedDate'];

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';






  constructor(private apiService: ApiService, private commonService: CommonService, private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private toastrService: ToastrService,) {

    this.eventUpdationForm = this.fb.group({
      //name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.commonService.nameWithSpacePattern)]),
      documents: this.fb.array([this.createDocument()]),
      //docAttendanceName: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.commonService.nameWithSpacePattern)]),
      attendance: this.fb.array([this.createAttendanceDocument()]),
      selectedParticipants: this.fb.array([]) // FormArray to hold selected rows
    });

  };

  form1 = new FormGroup({

    searchControl: new FormControl('', [Validators.pattern(this.commonService.searchFilter)])

  })

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.eventId = params['eventid'];
    });
    //this.GetEventParticipants();
    this.DtoPagination.PageSize = 20;
    this.DtoPagination.SearchTerm = this.commonService.searchText;
    
  };

  ngAfterViewInit() {
    this.loadEventIADocemntDetails();
    this.loadEventIAAttendanceWithUdyamDetails();     
  } 

  // Create a new FormGroup for each document
  createDocument(): FormGroup {
    return this.fb.group({
      name: ['', Validators.required],  // Document name required
      file: [null, Validators.required]  // File input required
    });
  }

  // Create a new FormGroup for each document
  createAttendanceDocument(): FormGroup {
    return this.fb.group({
      docAttendanceName: ['', Validators.required],  // Document name required
      file: [null, Validators.required]  // File input required
    });
  }

  loadEventIADocemntDetails() {
    this.DtoPagination.UniqueEventId = this.eventId;
    if (!this.pagination) return;
    // Unsubscribe from previous subscription to prevent multiple API calls
    if (this.loadEventDocSubscription) {
      this.loadEventDocSubscription.unsubscribe();
    }

    this.loadEventDocSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      //this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          //this.pagination.pageIndex = 0;
          //this.DtoPagination.SortColumn = this.sort.active;
          //this.DtoPagination.SortDirection = this.sort.direction;
          //this.DtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService
            .getRequest(API_ENDPOINTS.IA.GETEVENTIADOCUMENTS, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp['totalRecords'];
          }
          return resp?.data || {};
        })
      )
      .subscribe(data => {
        this.DocumentDetailsData = data;
        //this.adjustPaginator();
      });
  }

  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    });
  }

  onSearchChange(e: any) {
    this.DtoPagination.SearchTerm = e.target.value;
    this.DtoPagination.PageNumber = 1;
    this.loadEventIADocemntDetails();
  }
  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.loadEventIADocemntDetails();
  }

  onSearchClick(searchValue: string): void {
    const searchControl = this.form1.get('searchControl');


    if (searchControl?.value && searchValue.trim() !== '') {
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.loadEventIADocemntDetails();
    } else if (searchValue.trim() === '') {
      searchControl?.markAsTouched();
    } else {
      searchControl?.markAsTouched();
    }
  }
    loadEventIAAttendanceWithUdyamDetails() {
    this.DtoPagination.UniqueEventId = this.eventId;
    if (!this.pagination) return;
    // Unsubscribe from previous subscription to prevent multiple API calls
      if (this.loadEventAttendanceSubscription) {
        this.loadEventAttendanceSubscription.unsubscribe();
      }

      this.loadEventAttendanceSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService
            .getRequest(API_ENDPOINTS.IA.GETEVENTIAATTENDANCEWITHUDYAM, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp['totalRecords'];
          }
          return resp?.data || {};
        })
      )
      .subscribe(data => {
        this.AttendanceDetailsData = data;
        this.adjustPaginator();
      });
  }

  
}
